/*
 * @Author: Teemo Ding
 * @Date: 2021-11-25 15:38:49
 * @LastEditTime: 2022-06-07 17:51:35
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/AdditionalItem/AdditionalItemCategory.tsx
 */
import { Button, DropDown, Menu, MenuItem } from '@/src/components/Antd';
import {
  approveAdditionalItemRequest,
  rejectAdditionalItemRequest,
} from '@/src/request/order/additionalItem';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import { AdditionalStatus } from '@/src/types/common/order';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { modal } from '@/src/utils/Modal';
import { useRequest } from 'ahooks';
import React, { Fragment, useState } from 'react';
import { SectionWrapper } from 'src/components/Layouts';
//import css from './css.module.less';
import ModalHoc from 'src/constrains/ModalHOC';
import AdditionalItem from '../../../Components/Additional';
import RefundCard from '../../../Components/RefundCard';
import ReturnReject from '../../../Components/ReturnReject';
import { getMaxTimeline } from '../tools';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = () => {
  const canApprove = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderAdditionalItem,
        operation: EnumOperation.approve,
      }),
    ],
  });
  const canReject = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderAdditionalItem,
        operation: EnumOperation.reject,
      }),
    ],
  });
  return {
    canApprove,
    canReject,
  };
};

const AdditionalItemCategory = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const { canApprove, canReject } = permissions();
  const {
    modalOp,
    data,
    orderNo,
    onUpdate,
    salesChannelUuid,
    orderUuid,
    disabled,
    currencyCode,
  } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
  } = modalOp;
  const { uuid = '', items = [], timelines = [], requestNo = '' } = data || [];
  const additionalItems = (items || []).map((item) => {
    delete item.children;
    return item;
  });
  const [edit, setEdit] = useState(false);
  const { run: _approveAdditionalItemRequest } = useRequest(
    () => approveAdditionalItemRequest({ uuid }),
    {
      manual: true,
      onSuccess: (res) => {
        if (onUpdate) onUpdate(res);
      },
    },
  );
  const { run: _rejectAdditionalItemRequest } = useRequest(
    (data) => rejectAdditionalItemRequest(data),
    {
      manual: true,
      onSuccess: (res) => {
        if (onUpdate) onUpdate(res);
      },
    },
  );
  const handleReject = () => {
    setWidth(600);
    setShowModal(true);
    setModalTitle(getI18n('general.reject'));
    setModalContent(
      <ReturnReject
        type='rejectAdditional'
        onSubmit={(data) => _rejectAdditionalItemRequest({ ...data, uuid })}
        onModalCancel={onModalCancel}
      />,
    );
  };

  const overlay = (
    <Menu>
      <MenuItem className={css.menuItem} onClick={() => setEdit(true)}>
        {getI18n('general.edit')}
      </MenuItem>
    </Menu>
  );

  const handleApprove = () => {
    modal.info({
      title: getI18n(
        `allOrders.orderDetail.additionalItemCategory_handleApprove_title`,
      ),
      content: getI18n(
        `allOrders.orderDetail.additionalItemCategory_handleApprove_content`,
      ),
      onOkText: getI18n(
        `allOrders.orderDetail.additionalItemCategory_handleApprove_onOkText`,
      ),
      onCancelText: getI18n(
        `allOrders.orderDetail.additionalItemCategory_handleApprove_onCancelText`,
      ),
      onOk: () => {
        _approveAdditionalItemRequest();
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  };
  const handleOnSave = (res) => {
    setEdit(false);
    onUpdate(res);
  };
  const refundCardButton = (
    <Fragment>
      <Button type='primary' onClick={handleApprove} disabled={!canApprove}>
        {getI18n(
          `allOrders.orderDetail.additionalItemCategory_refundCardButton_approveBtn`,
        )}
      </Button>
      <Button onClick={handleReject} disabled={!canReject}>
        {getI18n(
          `allOrders.orderDetail.additionalItemCategory_refundCardButton_rejectBtn`,
        )}
      </Button>
      <DropDown overlay={overlay} placement='bottomRight' trigger={['click']}>
        <Button
          icon={<Icon type='iconMore' />}
          className={css.extendButton}></Button>
      </DropDown>
    </Fragment>
  );
  return (
    <SectionWrapper
      title={
        edit
          ? getI18n(
              `allOrders.orderDetail.additionalItemCategory_return_SectionWrapper_titleyes`,
            )
          : getI18n(
              `allOrders.orderDetail.additionalItemCategory_return_SectionWrapper_titleno`,
            )
      }
      subtitle={
        edit
          ? getI18n(
              `allOrders.orderDetail.additionalItemCategory_return_SectionWrapper_subtitleyes`,
            )
          : null
      }>
      {edit ? (
        <AdditionalItem
          salesChannelUuid={salesChannelUuid}
          AdditionalUuid={uuid}
          orderUuid={orderUuid}
          disable={disabled}
          selectedItems={additionalItems}
          onSave={handleOnSave}
          currency={currencyCode}
        />
      ) : (
        <RefundCard
          title={`#${orderNo || ''}-${requestNo} (${items.length} ${getI18n(
            'general.items',
          )})`}
          refundCardButton={refundCardButton}
          cardIntroduce={[
            {
              name: getI18n(
                `allOrders.orderDetail.additionalItemCategory_return_RefundCard_cardIntroduce`,
              ),
              text: getMaxTimeline(timelines || [], AdditionalStatus.Requested),
            },
          ]}
        />
      )}
    </SectionWrapper>
  );
};

export default ModalHoc(AdditionalItemCategory, { width: 600 });
